import React from "react";
import { Unit, UnitsWrapper } from "./UnitSelection.styled";

const UnitSelection: React.FC<{
  units: string;
  setUnits: (units: string) => void;
}> = ({ units, setUnits }) => {
  return (
    <UnitsWrapper>
      <Unit active={units === "kph"} onClick={() => setUnits("kph")}>
        KPH
      </Unit>
      <Unit active={units === "mph"} onClick={() => setUnits("mph")}>
        MPH
      </Unit>
      <Unit active={units === "knt"} onClick={() => setUnits("knt")}>
        KNTS
      </Unit>
    </UnitsWrapper>
  );
};

export default UnitSelection;
